import React from "react";

function OurAchievementSection() {
  return (
    <section className="py-16 bg-[#f3f8fa]">
      <div className="container mx-auto px-4">
        {/* Heading */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Our Achievements
          </h2>
          <p className="text-gray-600 text-base md:text-lg">
            Marketing experts in your niche with proven ROI results, backed by unbiased monitoring. Consistent unbiased monitoring to assure optimal results and accountability.
          </p>
        </div>

        {/* Image */}
        <div className="mb-12 relative flex justify-center">
          {/* You can replace this with an actual decorative element */}
          <img
            src="assets/images/home/exponent-marketing-achivements-1.jpg"
            alt="Achievement Banner"
            className="w-full max-w-4xl rounded-lg shadow-md object-cover"
          />
        </div>

        {/* Features Row */}
        <div className="flex flex-wrap justify-center text-center gap-8">
          {/* Feature 1 */}
          <div className="w-full sm:w-1/2 md:w-1/3 px-4">
            <div className="flex flex-col items-center">
              <img
                src="https://cdn-icons-png.flaticon.com/512/684/684908.png"
                alt="Flag Icon"
                className="w-12 h-12 mb-4"
              />
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                Marketing Firm is founded
              </h3>
              <p className="text-gray-600 text-sm max-w-xs">
                We provide monthly audit reports that identify the gaps that need to be overcome, and the opportunities that should be seized.
              </p>
            </div>
          </div>

          {/* Feature 2 */}
          <div className="w-full sm:w-1/2 md:w-1/3 px-4">
            <div className="flex flex-col items-center">
              <img
                src="https://cdn-icons-png.flaticon.com/512/847/847969.png"
                alt="Reporting Icon"
                className="w-12 h-12 mb-4"
              />
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                Built-in advanced reporting
              </h3>
              <p className="text-gray-600 text-sm max-w-xs">
                We provide monthly audit reports that identify the gaps that need to be overcome, and the opportunities that should be seized.
              </p>
            </div>
          </div>

          {/* Feature 3 */}
          <div className="w-full sm:w-1/2 md:w-1/3 px-4">
            <div className="flex flex-col items-center">
              <img
                src="https://cdn-icons-png.flaticon.com/512/747/747376.png"
                alt="Integration Icon"
                className="w-12 h-12 mb-4"
              />
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                Account Integration
              </h3>
              <p className="text-gray-600 text-sm max-w-xs">
                We provide monthly audit reports that identify the gaps that need to be overcome, and the opportunities that should be seized.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OurAchievementSection;
